import React, { Component } from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import {
  Menu, MenuItem, SwipeableDrawer, Tooltip,
} from '@material-ui/core';

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { getUniqueNumber } from '../Utils/Common';
import Bin from '../../assets/images/bin.svg';
import VectorTag from '../../assets/images/VectorTag.svg';
import CorrectMark from '../../assets/images/correctMark.svg';
import { doDeleteNotification, doUpdateNotification, getNotificationList } from '../../actions';

const state = {
  notificationAction: null,
  notificationList: [],
  currentNotificationId: null,
  currentNotificationIndex: null,
  redirect: false,
};

class NotificationList extends Component {
  constructor(props) {
    super(props);
    this.state = state;
  }

  componentDidMount() {
    this.refreshNotificaitonList();
  }

  notificationActionsMenu = (e, id, index) => {
    this.setState({
      notificationAction: e.currentTarget,
      currentNotificationId: id,
      currentNotificationIndex: index,
    });
  };

  notificationActionsMenuClose = () => {
    this.setState({ notificationAction: null });
  };

  deleteNotification = () => {
    const {
      currentNotificationId,
      notificationList,
      currentNotificationIndex,
    } = this.state;
    const { updateHeader } = this.props;

    doDeleteNotification(currentNotificationId)
      .then(() => {
        if (currentNotificationId === -1) {
          this.setState({
            notificationList: [],
            notificationAction: null,
          });
        } else {
          const list = notificationList;

          list.splice(currentNotificationIndex, 1);

          this.setState({
            notificationList: list,
            notificationAction: null,
          });
        }
        updateHeader(false);
      });
  };

  readNotification = () => {
    const {
      currentNotificationId,
      notificationList,
      currentNotificationIndex,
    } = this.state;
    const { updateHeader } = this.props;

    doUpdateNotification(currentNotificationId)
      .then(() => {
        let list = notificationList;
        if (currentNotificationId === -1) {
          list = list.map((notification) => (
            {
              ...notification,
              isRead: true,
            }
          ));
        } else {
          const currentNotification = list[currentNotificationIndex];
          currentNotification.isRead = true;
          list[currentNotificationIndex] = currentNotification;
        }
        this.setState({
          notificationList: list,
          notificationAction: null,
        });
        updateHeader(false);
      });
  };

  redirectNotification = (e, notification, index) => {
    e.preventDefault();
    this.setState({
      currentNotificationId: notification.id,
      currentNotificationIndex: index,
    }, () => {
      this.readNotification();
      const { history } = this.props;
      history.push(notification.targetLink);
    });
  };

  refreshNotificaitonList = () => {
    getNotificationList()
      .then((res) => {
        this.setState({ notificationList: res.data.rows && (res.data.rows || []) });
      })
      .catch(() => {
        this.setState({ notificationList: [] });
      });
  };

  render() {
    const {
      classes,
      notificationMenu,
      changeNotificationMenu,
    } = this.props;

    const {
      notificationList,
      notificationAction,
    } = this.state;

    return (
      <SwipeableDrawer
        anchor="right"
        open={notificationMenu}
        onClose={() => changeNotificationMenu(false)}
        onOpen={() => changeNotificationMenu(true)}
        className={classes.notificationMain}
      >
        <div className={classes.notificationList}>
          <div className={classes.notificationListHeading}>
            <img src={VectorTag} alt="" />
            <h3>
              Notifications

            </h3>

            <Tooltip title="Mark all as read">
              <div
                aria-hidden="true"
                className="notificationListHeadIcon"
                onClick={() => this.setState({ currentNotificationId: -1 }, this.readNotification)}
              >
                <img src={CorrectMark} alt="" />
              </div>
            </Tooltip>
            <Tooltip title="Delete all">
              <div
                aria-hidden="true"
                className="notificationListHeadIcon"
                onClick={() => this.setState({ currentNotificationId: -1 }, this.deleteNotification)}
              >
                <img src={Bin} alt="" />
              </div>
            </Tooltip>
          </div>
          <ul>
            {notificationList?.length > 0
              ? notificationList && notificationList.map((notification, i) => (
                <li key={getUniqueNumber()}>
                  <div className="unread">&nbsp;</div>
                  <a href={notification.targetLink} onClick={(e) => this.redirectNotification(e, notification, i)}>
                    <Tooltip title={notification.content}>
                      <div className="notification-detail">
                        <div className="notification-title">
                          {notification.label}
                        </div>
                        <div className="notification-time">
                          {moment(notification.createdAt)
                            .format('dddd MMMM Do YYYY, h:mm A')}
                        </div>
                      </div>
                    </Tooltip>
                  </a>
                  <div className="notification-actions">
                    <Tooltip title="Actions">
                      <MoreVertIcon onClick={(e) => this.notificationActionsMenu(e, notification.id, i)} />
                    </Tooltip>
                  </div>
                </li>
              ))
              : <li style={{ padding: '15px' }}>No notification found!</li>}
          </ul>
        </div>
        <Menu
          id="simple-menu"
          anchorEl={notificationAction}
          keepMounted
          open={!!notificationAction}
          onClose={this.notificationActionsMenuClose}
        >
          <MenuItem onClick={this.readNotification}>
            <CheckCircleOutlineIcon />
            &nbsp;
            <span>Mark As Read</span>
          </MenuItem>
          <MenuItem onClick={this.deleteNotification}>
            <DeleteForeverIcon />
            &nbsp;
            <span>Delete</span>
          </MenuItem>
        </Menu>

      </SwipeableDrawer>

    );
  }
}

export default withRouter(NotificationList);
